import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Efficiency, IWorkDetailRequestBody } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { ApiState } from "@baseTypes/baseType";
import { createThunk } from "../../crops/selector";
import { dashboardURL } from "@utils/utils";
import { applyExtraReducer } from "../../../weather";

export type EfficiencySliceState = {
    data: Efficiency
} & ApiState

const initialState: EfficiencySliceState = {
    apiError: undefined,
    isApiLoading: false,
    data: {
        totalWorkDuration: 0,
        totalTransportationDuration: 0,
        totalIdleDuration: 0,
        efficiencyForToday: {
            totalWorkDuration: 0,
            totalTransportationDuration: 0,
            totalIdleDuration: 0,
        }
    }
}

const fetchEfficiency = createThunk<Efficiency, IWorkDetailRequestBody, IWorkDetailRequestBody>()({
    url: dashboardURL('efficiency'),
    method: "POST",
}, (payload, url) => ({ url, data: payload }))

const efficiencySlice = createSlice({
    name: 'efficiencySlice',
    initialState,
    reducers: {},
    extraReducers: builder => {
        applyExtraReducer(builder, fetchEfficiency, {
            fulfillReducer: (state: EfficiencySliceState, action: PayloadAction<Efficiency>) => {
                state.data = action.payload
            }
        })
    }
})

export const actions = { ...efficiencySlice.actions, fetchEfficiency }

export default efficiencySlice.reducer